var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont-pages"},[_c('CoreBanner'),_c('CoreCoverage'),_c('ProductCoreAbout'),_c('ProductCoreTabs'),_c('FibreProcess')],1)}
var staticRenderFns = []

export { render, staticRenderFns }